import React from 'react';
import PropTypes from 'prop-types';
import withTranslation from '../../hoc/withTranslation';
import { Avatar, Chip, Paper, Subheader } from 'material-ui';
import style from '../../styles/styles';
import Info from '../common/Info/Info';
import Timestamp from 'react-timestamp';

class RoadBookConfigurationInfo extends React.Component {
    static propTypes = {
        roadBookConfiguration: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        lang: PropTypes.string,
        trail: PropTypes.object,
        sortCustomField: PropTypes.object,
        hostingTypes: PropTypes.array,
        pointTypes: PropTypes.array,
    };

    static defaultProps = {
        hostingTypes: [],
        pointTypes: [],
    };

    render() {
        const {
            roadBookConfiguration,
            trail,
            hostingTypes,
            pointTypes,
            sortCustomField,
            t,
        } = this.props;
        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {t('generic.information')}
                </Subheader>
                <div style={style.paper}>
                    {!roadBookConfiguration.is_activated
                        && <p
                            style={{
                                marginTop: 0,
                                marginBottom: '2em',
                                color: 'rgb(117, 117, 117)',
                                fontStyle: 'italic',
                            }}
                        >
                            {t('module.road_book.road_book_configuration_disabled')}
                        </p>}
                    <Info
                        title={t('generic.identifier')}
                        content={roadBookConfiguration.id}
                    />
                    {roadBookConfiguration.name &&
                        <Info
                            title={t('generic.name')}
                            content={roadBookConfiguration.name}
                        />
                    }
                    <Info
                        title={t('module.open_explore.trail')}
                        content={trail
                            ? trail.name
                            : t('module.open_explore.no_trail')}
                    />
                    <Info
                        title={t('module.road_book.daily_distance_min')}
                        content={roadBookConfiguration.daily_distance_min}
                    />
                    <Info
                        title={t('module.road_book.daily_distance_max')}
                        content={roadBookConfiguration.daily_distance_max}
                    />
                    <Info
                        title={t('module.road_book.point_distance_max')}
                        content={roadBookConfiguration.point_distance_max}
                    />
                    <Info
                        title={t('module.road_book.hosting_distance_max')}
                        content={roadBookConfiguration.hosting_distance_max}
                    />
                    {/* custom field */}
                    {hostingTypes && hostingTypes.length > 0
                        && <Info title={t('module.road_book.hosting_types')} divider={false}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                }}
                            >

                                {hostingTypes.map(type =>
                                    <Chip
                                        key={'hosting_type_' + type.id}
                                        style={{
                                            marginLeft: '5px',
                                            marginRight: '5px',
                                        }}
                                    >
                                        <Avatar
                                            icon={type.picture
                                                && <img src={type.picture}
                                                        alt=""
                                                        style={style.image.contain}
                                                />}
                                            size={20}
                                            backgroundColor={type.color}
                                            style={{ overflow: 'hidden' }}
                                        />
                                        {type.name}
                                    </Chip>)}
                            </div>
                        </Info>}
                    {
                        pointTypes && pointTypes.length > 0
                        && <Info
                            title={t('module.road_book.point_types')}
                            divider={false}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {
                                    pointTypes.map(type =>
                                        <Chip
                                            key={'point_type_' + type.id}
                                            style={{
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                            }}
                                        >
                                            <Avatar
                                                icon={type.picture
                                                    && <img
                                                        src={type.picture}
                                                        alt=""
                                                        style={style.image.contain}
                                                    />}
                                                size={20}
                                                backgroundColor={type.color}
                                                style={{ overflow: 'hidden' }}
                                            />
                                            {type.name}
                                        </Chip>,
                                    )}
                            </div>
                        </Info>}
                    <Info
                        title={t('module.road_book.sort_custom_field')}
                        content={sortCustomField && sortCustomField.name}
                    />
                    <Info
                        title={t('generic.created_at')}
                        content={
                            <Timestamp
                                time={roadBookConfiguration.created_at}
                                format="full"
                                twentyFourHour
                            />
                        }
                    />
                    <Info
                        title={t('generic.updated_at')}
                        content={(
                            roadBookConfiguration.updated_at &&
                            <Timestamp time={roadBookConfiguration.updated_at} format="full"
                                       twentyFourHour />
                        ) || t('generic.updated_never')}
                        divider={false}
                    />
                </div>
            </Paper>
        );
    }
}

export default withTranslation(RoadBookConfigurationInfo);



// WEBPACK FOOTER //
// src/components/roadbook/RoadBookConfigurationInfo.js